"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AggregationJSONModel = exports.defaultAggregation = exports.Aggregation = void 0;
var Aggregation;
(function (Aggregation) {
    Aggregation["dau"] = "dau";
    Aggregation["wau"] = "wau";
    Aggregation["mau"] = "mau";
})(Aggregation = exports.Aggregation || (exports.Aggregation = {}));
exports.defaultAggregation = Aggregation.dau;
class AggregationJSONModel {
    constructor(serializedState) {
        this.reset = () => {
            this.resetAggregation();
        };
        this.overwriteFromSerializedState = (serializedState) => {
            this.setAggregation(serializedState);
        };
        this.serialize = () => {
            return this.aggregation;
        };
        ////////////////////////////////////////////////
        // Aggregation
        ////////////////////////////////////////////////
        this.getAggregation = () => this.aggregation;
        this.setAggregation = (value) => this.aggregation = validateAggregation(value);
        this.resetAggregation = () => this.setAggregation(undefined);
        this.reset();
        this.overwriteFromSerializedState(serializedState);
    }
}
exports.AggregationJSONModel = AggregationJSONModel;
const validateAggregation = (value) => {
    if (typeof value === "string" && value in Aggregation) {
        return value;
    }
    return exports.defaultAggregation;
};
